import { useNavigate } from "react-router-dom";
import { BackButton } from "../../styles/AddAdherense";
import {
  CancelPlansTitle,
  CancelPlanStyle,
  WrapContent,
  WrapTitleAndSmallText,
  Select,
  Table,
  Th,
  Td,
} from "../../styles/CancelPlan";
import { HOME_LOGGED } from "../../core/app-urls";
import { useEffect, useMemo, useState } from "react";
import { getContractsPF } from "../../data/services/person_service";
import { getListOfCanceledPlans } from "../../data/services/enterprise_service";
import WitnessContractModel from "../../data/models/witness";

const parseValor = (valor: unknown): number => {
  if (typeof valor === "number") return valor;
  if (typeof valor !== "string") return 0;

  const normalized = valor
    .replace(/[^\d,.-]/g, "")
    .replace(/\.(?=\d{3}(?:\D|$))/g, "")
    .replace(",", ".");

  const parsed = parseFloat(normalized);
  return isNaN(parsed) ? 0 : parsed;
};

export default function AgreementHistory() {
  const navigate = useNavigate();

  const [contracts, setContracts] = useState<any[]>([]);
  const [selectedContractId, setSelectedContractId] = useState<string>("");
  const [statusFilter, setStatusFilter] = useState<string>("todos");

  const [historicalContracts, setHistoricalContracts] = useState<WitnessContractModel[]>([]);

  const [loading, setLoading] = useState<boolean>(false);

  const handleLogout = () => {
    navigate(HOME_LOGGED);
  };

  const fetchContracts = async () => {
    setLoading(true);

    try {
      const response = await getContractsPF();

      if (response.data) {
        setContracts(response.data);
      } else {
        console.error("Não foi possível carregar os contratos.");
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchContracts();
  }, []);

  const handleContractChange = async (contractId: string) => {
    setSelectedContractId(contractId);

    if (!contractId) {
      setHistoricalContracts([]);
      return;
    }

    setLoading(true);

    try {
      const response = await getListOfCanceledPlans(contractId);
      setHistoricalContracts(response.data || []);
    } finally {
      setLoading(false);
    }
  };

  const filteredHistoricalContracts = useMemo(() => {
    if (statusFilter === "todos") {
      return historicalContracts;
    }

    return historicalContracts.filter((contract) => {
      const status = contract.status?.toLowerCase().trim();

      if (statusFilter === "ativos") {
        return status === "ativo";
      }

      if (statusFilter === "cancelados") {
        return status === "cancelado";
      }

      return true;
    });
  }, [historicalContracts, statusFilter]);

  const totalValor = useMemo(() => {
    return filteredHistoricalContracts.reduce(
      (sum, contract) => sum + parseValor(contract.valor_plano),
      0
    );
  }, [filteredHistoricalContracts]);

  const formattedTotalValor = totalValor.toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
  });

  return (
    <CancelPlanStyle>
      <WrapContent>
        <BackButton onClick={handleLogout}>VOLTAR</BackButton>

        <WrapTitleAndSmallText>
          <CancelPlansTitle>Histórico de Conveniados</CancelPlansTitle>
          <p>
            Selecione o número do contrato para visualizar o histórico de
            conveniados.
          </p>
        </WrapTitleAndSmallText>

        <div>

          <Select
            value={selectedContractId}
            onChange={(e) => handleContractChange(e.target.value)}
          >
            <option value="">Selecione o número do contrato</option>

            {contracts.map((contract) => (
              <option key={contract.idContrato} value={contract.idContrato}>
                {contract.numero_contrato}
              </option>
            ))}
          </Select>

          <Select
            value={statusFilter}
            onChange={(e) => setStatusFilter(e.target.value)}
            disabled={!selectedContractId}
          >
            <option value="todos">Todos</option>
            <option value="ativos">Ativos</option>
            <option value="cancelados">Cancelados</option>
          </Select>
        </div>

        <div style={{ maxHeight: "400px", overflowY: "auto", width: "100%" }}>
          <Table>
            <thead>
              <tr>
                <Th>NOME</Th>
                <Th>CNPJ</Th>
                <Th>CPF</Th>
                <Th>STATUS</Th>
                <Th>DATA FINAL</Th>
                <Th>Plano</Th>
                <Th>Valor</Th>
              </tr>
            </thead>

            <tbody>
              {filteredHistoricalContracts.length > 0 ? (
                <>
                  {filteredHistoricalContracts.map((contract, index) => (
                    <tr key={index}>
                      <Td>{contract.nomeAssociado}</Td>
                      <Td>{contract.cnpjAssociado}</Td>
                      <Td>{contract.cpfAssociado}</Td>
                      <Td>{contract.status}</Td>
                      <Td>
                        {contract.status?.toLowerCase() === "ativo"
                          ? "-"
                          : contract.dataFinal
                            ? new Date(contract.dataFinal).toLocaleDateString(
                              "pt-BR"
                            )
                            : "-"}
                      </Td>
                      <Td>{contract.plano}</Td>
                      <Td>R$ {contract.valor_plano}</Td>
                    </tr>
                  ))}
                  <tr>
                    <Td colSpan={6} style={{ textAlign: "right", fontWeight: "bold" }}>
                      Total
                    </Td>
                    <Td style={{ fontWeight: "bold" }}>{formattedTotalValor}</Td>
                  </tr>
                </>
              ) : (
                <tr>
                  <Td colSpan={7} style={{ textAlign: "center" }}>
                    {loading ? "Carregando..." : "Nenhum resultado encontrado."}
                  </Td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </WrapContent>
    </CancelPlanStyle>
  );
}